<script>
import { changePassword } from '../services/userService'

const defaultErrors = {
  oldPassword: null,
  newPassword: null,
  confirmPassword: null
}

export default {
  name: 'SecurityView',
  data() {
    return {
      passwordForm: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
      },
      errors: { ...defaultErrors },
      loading: false,
      visible: false
    }
  },
  methods: {
    openModal() {
      this.visible = true
    },
    closeModal() {
      this.visible = false
    },
    successMessage() {
      this.$snackbar.open({
        message: 'Your password has been updated',
        type: 'is-secondary',
        position: 'is-bottom-left'
      })
    },
    async changePassword() {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm
      try {
        if (oldPassword.length === 0) {
          return (this.errors = {
            ...defaultErrors,
            oldPassword: 'Please enter your old password.'
          })
        } else if (newPassword.length === 0) {
          return (this.errors = {
            ...defaultErrors,
            newPassword: 'Please enter your new password.'
          })
        } else if (confirmPassword.length === 0) {
          return (this.errors = {
            ...defaultErrors,
            confirmPassword: 'Please confirm your password.'
          })
        } else if (newPassword !== confirmPassword) {
          return (this.errors = {
            ...defaultErrors,
            confirmPassword: 'Passwords do not match.'
          })
        }

        this.loading = true
        const userData = await changePassword(this.passwordForm)
        this.loading = false

        if (userData) {
          this.errors = { ...defaultErrors }
          this.successMessage()
          this.closeModal()
        }
      } catch (error) {
        this.loading = false
        switch (error.message) {
          case 'GraphQL error: Passwords do not match':
            return (this.errors = {
              ...defaultErrors,
              confirmPassword: 'Passwords do not match.'
            })
          case 'GraphQL error: Wrong password':
            return (this.errors = {
              email: null,
              password: 'The password you entered is incorrect.'
            })

          default:
            break
        }
      }
    }
  }
}
</script>

<template>
  <div class="section container account-view">
    <div class="change-password-form">
      <h2 class="title">Change password</h2>

      <form @submit.prevent="changePassword">
        <b-field
          label="Old password"
          :type="{ 'is-danger': !!errors.oldPassword }"
          :message="errors.oldPassword"
        >
          <b-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="Your old password"
            password-reveal
            required
          />
        </b-field>
        <b-field
          label="New password"
          :type="{ 'is-danger': !!errors.newPassword }"
          :message="errors.newPassword"
        >
          <b-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="Type your new password"
            password-reveal
            required
          />
        </b-field>
        <b-field
          label="Confirm password"
          :type="{ 'is-danger': !!errors.confirmPassword }"
          :message="errors.confirmPassword"
        >
          <b-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="Type your new password one more time"
            password-reveal
            required
          />
        </b-field>
        <button
          class="button is-primary is-rounded"
          type="submit"
          :disabled="loading"
        >
          Update password
        </button>
      </form>
    </div>
  </div>
</template>

<style lang="sass">
.change-password-form form
  max-width: 340px
</style>
